import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export const SITE_URL = process.env.REACT_APP_SITE_URL || window.location.origin;

export const FRANK_PHOTO =
  "https://yourrealtorfrank.com/wp-content/uploads/2026/08/l1zhr0z4_2BC9B76D-1F1E-4ECE-A682-096C82AF98D0-600x600.png";

export const IMAGES = {
  hero: "/images/hero.jpg",
  redrock: "/images/redrock.jpg",
  military: "/images/military.jpg",
  barracks: "/images/barracks.jpg",
  hummingbird: "/images/hummingbird.jpg",
  dahlia: "/images/dahlia.jpg",
};

export const CAT_IMAGES = {
  "moving-to-sierra-vista": IMAGES.hero,
  "fort-huachuca-military": IMAGES.military,
  "things-to-do-outdoors": IMAGES.hummingbird,
  "weather-climate": IMAGES.redrock,
  "family-life-parks": IMAGES.dahlia,
  "jobs-employment": IMAGES.barracks,
  "hereford-general": IMAGES.hummingbird,
  "hereford-real-estate": IMAGES.redrock,
  "hereford-birding": IMAGES.dahlia,
  "hereford-land": IMAGES.hero,
  "huachuca-city-general": IMAGES.military,
  "huachuca-city-fort": IMAGES.barracks,
  "huachuca-city-land": IMAGES.redrock,
  "bisbee-things-to-do": IMAGES.redrock,
  "bisbee-queen-mine": IMAGES.barracks,
  "bisbee-outdoors": IMAGES.hero,
  "bisbee-arts": IMAGES.dahlia,
  "tombstone-things-to-do": IMAGES.barracks,
  "tombstone-ok-corral": IMAGES.military,
  "tombstone-outdoors": IMAGES.hero,
  "tombstone-events": IMAGES.dahlia,
  "benson-about": IMAGES.hero,
  "benson-kartchner": IMAGES.redrock,
  "benson-things-to-do": IMAGES.hummingbird,
  "benson-history-western": IMAGES.barracks,
  "douglas-about": IMAGES.military,
  "douglas-history": IMAGES.barracks,
  "douglas-border": IMAGES.redrock,
  "willcox-about": IMAGES.redrock,
  "willcox-wine": IMAGES.dahlia,
  "willcox-chiricahua": IMAGES.hero,
  "sahuarita-about": IMAGES.dahlia,
  "sahuarita-things-to-do": IMAGES.redrock,
  "sahuarita-nearby": IMAGES.hummingbird,
  "vail-about": IMAGES.redrock,
  "vail-things-to-do": IMAGES.hero,
  "vail-history": IMAGES.barracks,
  "sonoita-about": IMAGES.hummingbird,
  "sonoita-wine": IMAGES.dahlia,
  "sonoita-outdoors": IMAGES.hero,
};

export const TESTIMONIALS = [
  {
    quote:
      "Working with Frank was an outstanding experience from start to finish. No matter when I called or texted, he was quick to respond — evenings and weekends included. He handled every detail of the paperwork with care and precision, negotiated a great deal on my behalf, and is simply a genuine, trustworthy person. I highly recommend him to anyone buying or selling in Cochise County.",
    name: "Greg",
    where: "Cochise County, AZ",
  },
  {
    quote:
      "Frank brought a buyer to my for-sale-by-owner house and was an excellent facilitator for the transaction. He was responsive, cheerful, understanding, and timely! I recommend him as an agent for sure.",
    name: "Nicole",
    where: "Southeast Arizona",
  },
];

export const SISTER_SITES = {
  com: {
    name: "YourRealtorFrank.com",
    url: "https://yourrealtorfrank.com",
    label: "Homes for Sale",
    badge: "Service First Realty",
    title: "Looking to Buy or Sell in Sierra Vista?",
    description:
      "Frank Powell and the Sierra Vista Home Selling Team at Service First Realty — MLS search, free home valuations, and veteran relocation help within 60 miles of Sierra Vista.",
    cta: "Search Sierra Vista Homes",
  },
  net: {
    name: "YourRealtorFrank.net",
    url: "https://yourrealtorfrank.net",
    label: "Real Estate School",
    badge: "Online School",
    title: "Learn Real Estate, Taught by AI",
    description:
      "Frank's online real estate school — free AI-powered classes on buying, selling, investing, mortgages and more, with quizzes, flashcards and a 24/7 tutor.",
    cta: "Start Learning Free",
  },
  us: {
    name: "YourRealtorFrank.us",
    url: "https://yourrealtorfrank.us",
    label: "Moving & Relocation Guide",
  },
  me: {
    name: "YourRealtorFrank.me",
    url: "https://yourrealtorfrank.me",
    label: "Meet Frank Powell",
  },
};

export const EVENTS = {
  "sierra-vista": [
    { month: "JUL", name: "Fourth of July at Veterans Memorial Park", detail: "Fireworks and family festivities at the city's biggest park." },
    { month: "AUG", name: "Southwest Wings Birding Festival", detail: "Guided walks and talks in the hummingbird capital region." },
    { month: "SEP", name: "Oktoberfest", detail: "German food, music and beer as the monsoon cools off." },
    { month: "DEC", name: "Holiday Parade of Lights", detail: "Lit floats and winter cheer down Fry Boulevard." },
  ],
  hereford: [
    { month: "MAY–SEP", name: "Hummingbird Banding at San Pedro House", detail: "See tiny migrants up close with local birding naturalists." },
    { month: "OCT", name: "San Pedro River Festival", detail: "Celebrating the river valley with walks, booths and music." },
    { month: "YEAR-ROUND", name: "Saturday Markets on Highway 92", detail: "Local produce, crafts and feed-store mornings." },
    { month: "SPRING", name: "Ramsey Canyon Migration Season", detail: "Peak hummingbirds and elegant trogons up the canyon." },
  ],
  "huachuca-city": [
    { month: "JUL", name: "Town Fourth of July Celebration", detail: "Small-town parade and fireworks in the Sunset City." },
    { month: "YEAR-ROUND", name: "Fort Huachuca Museum & Post Events", detail: "Museums, historic districts and community days next door." },
    { month: "OCT", name: "Fall Festival Season", detail: "Community-center events as the desert cools." },
    { month: "DEC", name: "Holiday Tree Lighting", detail: "Small-town Christmas at the heart of Highway 90." },
  ],
  bisbee: [
    { month: "JUN", name: "Bisbee Pride", detail: "One of Arizona's most colorful small-town pride weekends." },
    { month: "SEP", name: "Brewery Gulch Daze", detail: "Street party in the historic gulch." },
    { month: "OCT", name: "Bisbee 1000 Great Stair Climb", detail: "The famous race up Old Bisbee's staircases." },
    { month: "MONTHLY", name: "Bisbee After 5 Art Walk", detail: "Galleries stay open late through Old Bisbee." },
  ],
  tombstone: [
    { month: "YEAR-ROUND", name: "Gunfight Shows on Allen Street", detail: "Daily reenactments in the Town Too Tough To Die." },
    { month: "APR", name: "Rose Tree Festival", detail: "Celebrating the world's largest rose bush." },
    { month: "MAY", name: "Wyatt Earp Days", detail: "Memorial Day weekend honoring the lawman." },
    { month: "OCT", name: "Helldorado Days", detail: "Tombstone's legendary October blowout — parades, gunfights and contests." },
  ],
  benson: [
    { month: "YEAR-ROUND", name: "Kartchner Caverns Tours", detail: "The living cave, ten minutes south of town." },
    { month: "JUL", name: "Fourth of July Fireworks", detail: "Small-city celebration in the San Pedro valley." },
    { month: "OCT", name: "Butterfield Overland Stage Days", detail: "Benson's Old West stagecoach heritage festival." },
    { month: "WINTER", name: "Snowbird Season & RV Rallies", detail: "The valley fills with winter visitors and park events." },
  ],
  douglas: [
    { month: "MAY", name: "Cinco de Mayo on the Border", detail: "Binational food, music and parade culture." },
    { month: "SEP", name: "Cochise County Fair", detail: "The county fair at the Douglas fairgrounds — rodeo, exhibits and carnival." },
    { month: "YEAR-ROUND", name: "Gadsden Hotel Saturdays", detail: "Lobby history, marble staircase and border-town dining." },
    { month: "DEC", name: "Binational Holiday Posadas", detail: "Borderland Christmas traditions on both sides." },
  ],
  willcox: [
    { month: "JAN", name: "Wings Over Willcox", detail: "Sandhill cranes and raptor tours across the valley." },
    { month: "MAY", name: "Willcox Wine Country Spring Festival", detail: "Tasting rooms take over Railroad Avenue." },
    { month: "OCT", name: "Rex Allen Days", detail: "Rodeo, parade and concerts honoring the Arizona Cowboy." },
    { month: "OCT", name: "Willcox Wine Country Fall Festival", detail: "Harvest-season pouring in historic downtown." },
  ],
  sahuarita: [
    { month: "YEAR-ROUND", name: "Rancho Sahuarita Community Events", detail: "Lake concerts, festivals and family nights in the master plan." },
    { month: "OCT", name: "Fiesta Sahuarita", detail: "The town's big fall festival with music, food and vendors." },
    { month: "NOV", name: "Sahuarita Pecan Festival", detail: "Harvest celebration among the pecan groves." },
    { month: "DEC", name: "Holiday Events at Sahuarita Lake", detail: "Lights and festivities around the lake park." },
  ],
  vail: [
    { month: "FEB", name: "Vail Pride Day", detail: "The whole district turns out — booths, food and school spirit." },
    { month: "SPRING", name: "Cienega Creek Nature Season", detail: "Wildflowers and creek walks in the preserve (permits required)." },
    { month: "OCT", name: "Fall at Colossal Cave", detail: "Cooler-season cave tours and mountain-park events." },
    { month: "YEAR-ROUND", name: "Vail District Community Nights", detail: "School performances, sports and showcases across the district." },
  ],
  sonoita: [
    { month: "APR", name: "Blessing of the Sonoita Vineyards", detail: "The wine season opens in the grasslands." },
    { month: "MAY", name: "Sonoita Horse Races", detail: "Historic quarter-horse racing returns to the fairgrounds." },
    { month: "SEP", name: "Sonoita Labor Day Rodeo", detail: "One of Arizona's storied small-town rodeos." },
    { month: "SEP", name: "Santa Cruz County Fair", detail: "The county fair, held right at the Sonoita fairgrounds." },
  ],
};

export const CITIES = [
  {
    slug: "sierra-vista",
    path: "/",
    name: "Sierra Vista",
    zips: "85635 & 85650",
    eyebrow: "The Sierra Vista 365 Almanac",
    heroLines: ["*Eleven cities* of Southeast AZ.", "Answered daily."],
    heroSub:
      "Every question people ask about moving to and living in **Sierra Vista, Arizona — ZIP 85635 & 85650** — housing, Fort Huachuca, schools, jobs, cost of living and beyond. One new in-depth AI answer, every single day.",
    heroSearchPlaceholder: "Ask about Sierra Vista… e.g. VA loans, monsoon, 85650",
    image: IMAGES.hero,
    imageAlt: "Huachuca Mountains sunset over the Sierra Vista desert",
    marquee: [
      "ELEVATION 4,633 FT",
      "HUMMINGBIRD CAPITAL OF THE U.S.",
      "FORT HUACHUCA · EST. 1877",
      "MONSOON SEASON · JUL – SEP",
      "ZIP CODES 85635 & 85650",
      "COCHISE COUNTY · ARIZONA",
      "365 QUESTIONS · ONE NEW ANSWER DAILY",
      "SAN PEDRO RIPARIAN NCA",
    ],
    seoTitle: "365 Sierra Vista AZ Questions, Answered Daily — YourRealtorFrank.info",
    seoDesc:
      "365 questions people ask about Sierra Vista, AZ 85635 & 85650 — housing, Fort Huachuca, schools, jobs, cost of living — one new in-depth answer every day.",
    catEyebrow: "Frequently asked questions about Sierra Vista",
    catHeading: "Twenty shelves of the almanac",
    catSub:
      "Every one of the 365 questions lives under one of these twenty titles — from Fort Huachuca PCS moves to monsoon season and the 85635 / 85650 split.",
  },
  {
    slug: "hereford",
    path: "/hereford",
    name: "Hereford",
    zips: "85615",
    eyebrow: "The Hereford 365 Almanac",
    heroLines: ["*Eleven cities* of Southeast AZ.", "Answered daily."],
    heroSub:
      "Every question people ask about **Hereford, Arizona — ZIP 85615** — land and acreage, horse properties, wells and septic, birding the San Pedro valley, Palominas schools and quiet rural living minutes from Sierra Vista. One new in-depth AI answer, every single day.",
    heroSearchPlaceholder: "Ask about Hereford… e.g. horse property, wells, Ramsey Canyon",
    image: IMAGES.hummingbird,
    imageAlt: "Hummingbird feeding on desert blossoms near the San Pedro River valley, Hereford Arizona",
    marquee: [
      "SAN PEDRO RIVER VALLEY",
      "GATEWAY TO RAMSEY CANYON",
      "HORSE PROPERTY & ACREAGE COUNTRY",
      "ZIP 85615",
      "PALOMINAS · MIRACLE VALLEY",
      "MINUTES SOUTH OF SIERRA VISTA",
      "365 QUESTIONS · ONE NEW ANSWER DAILY",
      "MILLER CANYON · HUACHUCA MOUNTAINS",
    ],
    seoTitle: "365 Hereford AZ 85615 Questions, Answered Daily — YourRealtorFrank.info",
    seoDesc:
      "365 questions people ask about Hereford, AZ 85615 — land, acreage, horse properties, wells, birding, schools and rural living — one new in-depth answer every day.",
    catEyebrow: "Frequently asked questions about Hereford",
    catHeading: "Seventeen shelves of the valley almanac",
    catSub:
      "Every one of the 365 questions lives under one of these seventeen titles — from acreage and well depth to hummingbird season on the San Pedro.",
  },
  {
    slug: "huachuca-city",
    path: "/huachuca-city",
    name: "Huachuca City",
    zips: "85616 · Fort Huachuca 85613",
    eyebrow: "The Huachuca City 365 Almanac",
    heroLines: ["*Eleven cities* of Southeast AZ.", "Answered daily."],
    heroSub:
      "Every question people ask about **Huachuca City, Arizona — ZIP 85616, with Fort Huachuca at 85613** — homes, land, town water, schools, gate commutes and small-town life on Highway 90. One new in-depth AI answer, every single day.",
    heroSearchPlaceholder: "Ask about Huachuca City… e.g. water rates, 85616, gate commute",
    image: IMAGES.military,
    imageAlt: "Military helicopters over desert mountains near Fort Huachuca and Huachuca City, Arizona",
    marquee: [
      "THE SUNSET CITY",
      "HIGHWAY 90 · COCHISE COUNTY",
      "FORT HUACHUCA'S NORTH NEIGHBOR",
      "ZIP 85616 · FORT HUACHUCA 85613",
      "TOMBSTONE UNIFIED SCHOOLS",
      "365 QUESTIONS · ONE NEW ANSWER DAILY",
      "FAIRBANK HISTORIC TOWNSITE",
    ],
    seoTitle: "365 Huachuca City AZ 85616 Questions, Answered Daily — YourRealtorFrank.info",
    seoDesc:
      "365 questions people ask about Huachuca City, AZ 85616 and Fort Huachuca 85613 — homes, land, utilities, schools, gate commutes — one new answer every day.",
    catEyebrow: "Frequently asked questions about Huachuca City",
    catHeading: "Seventeen shelves of the Sunset City almanac",
    catSub:
      "Every one of the 365 questions lives under one of these seventeen titles — from 85616 vs 85613 to town water rates and the Fort Huachuca gate commute.",
  },
  {
    slug: "bisbee",
    path: "/bisbee",
    name: "Bisbee",
    zips: "85603",
    eyebrow: "The Bisbee 365 Almanac",
    heroLines: ["*Eleven cities* of Southeast AZ.", "Answered daily."],
    heroSub:
      "Every question people ask about **Bisbee, Arizona — ZIP 85603** — the Queen Mine, Old Bisbee's staircased streets, ghost tours, hotels, parking, restaurants, Mule Mountain hikes and life in Arizona's most storied mining town. One new in-depth AI answer, every single day.",
    heroSearchPlaceholder: "Ask about Bisbee… e.g. Queen Mine, ghost tours, parking",
    image: IMAGES.redrock,
    imageAlt: "Red rock mountain terrain like the Mule Mountains surrounding Bisbee, Arizona",
    marquee: [
      "THE QUEEN MINE · COPPER COUNTRY",
      "OLD BISBEE · VICTORIAN STREETS",
      "COPPER QUEEN HOTEL · EST. 1902",
      "ZIP 85603 · COCHISE COUNTY SEAT",
      "ELEVATION 5,538 FT · MULE MOUNTAINS",
      "BREWERY GULCH NIGHTLIFE",
      "365 QUESTIONS · ONE NEW ANSWER DAILY",
      "THE BISBEE 1000 STAIR CLIMB",
    ],
    seoTitle: "365 Bisbee AZ 85603 Questions, Answered Daily — YourRealtorFrank.info",
    seoDesc:
      "365 questions people ask about Bisbee, AZ 85603 — Queen Mine tours, Old Bisbee, hotels, restaurants, ghosts, weather and real estate — one new answer every day.",
    catEyebrow: "Frequently asked questions about Bisbee",
    catHeading: "Thirteen shelves of the copper city almanac",
    catSub:
      "Every one of the 365 questions lives under one of these thirteen titles — from the Queen Mine and ghost tours to where to park on those famous hills.",
  },
  {
    slug: "tombstone",
    path: "/tombstone",
    name: "Tombstone",
    zips: "85638",
    eyebrow: "The Tombstone 365 Almanac",
    heroLines: ["*Eleven cities* of Southeast AZ.", "Answered daily."],
    heroSub:
      "Every question people ask about **Tombstone, Arizona — ZIP 85638** — the O.K. Corral, gunfight reenactments, Allen Street saloons, Boothill Graveyard, haunted hotels, Helldorado Days and life in the most famous town of the Old West. One new in-depth AI answer, every single day.",
    heroSearchPlaceholder: "Ask about Tombstone… e.g. O.K. Corral, ghost tours, Helldorado",
    image: IMAGES.barracks,
    imageAlt: "Old West frontier camp in desert terrain like 1880s Tombstone, Arizona",
    marquee: [
      "THE TOWN TOO TOUGH TO DIE",
      "O.K. CORRAL · OCT 26, 1881",
      "ALLEN STREET SALOONS",
      "ZIP 85638 · COCHISE COUNTY",
      "BOOTHILL GRAVEYARD",
      "HELLDORADO DAYS · OCTOBER",
      "365 QUESTIONS · ONE NEW ANSWER DAILY",
      "ELEVATION 4,540 FT",
    ],
    seoTitle: "365 Tombstone AZ 85638 Questions, Answered Daily — YourRealtorFrank.info",
    seoDesc:
      "365 questions people ask about Tombstone, AZ 85638 — the O.K. Corral, Allen Street, ghost tours, hotels, events and real estate — one new answer every day.",
    catEyebrow: "Frequently asked questions about Tombstone",
    catHeading: "Thirteen shelves of the Old West almanac",
    catSub:
      "Every one of the 365 questions lives under one of these thirteen titles — from the O.K. Corral and Boothill to where to park on Allen Street.",
  },
  {
    slug: "benson",
    path: "/benson",
    name: "Benson",
    zips: "85602",
    eyebrow: "The Benson 365 Almanac",
    heroLines: ["*Eleven cities* of Southeast AZ.", "Answered daily."],
    heroSub:
      "Every question people ask about **Benson, Arizona — ZIP 85602** — Kartchner Caverns, the Mescal Movie Set, RV and snowbird life, the Amtrak stop, I-10 travel, schools and quiet San Pedro valley living. One new in-depth AI answer, every single day.",
    heroSearchPlaceholder: "Ask about Benson… e.g. Kartchner tickets, RV parks, Vigneto",
    image: IMAGES.hero,
    imageAlt: "Desert valley sunset over the San Pedro valley near Benson, Arizona",
    marquee: [
      "GATEWAY TO COCHISE COUNTY",
      "KARTCHNER CAVERNS STATE PARK",
      "I-10 · EXITS 302 – 306",
      "ZIP 85602 · SAN PEDRO VALLEY",
      "MESCAL MOVIE SET",
      "AMTRAK SUNSET LIMITED STOP",
      "365 QUESTIONS · ONE NEW ANSWER DAILY",
      "RV & SNOWBIRD COUNTRY",
    ],
    seoTitle: "365 Benson AZ 85602 Questions, Answered Daily — YourRealtorFrank.info",
    seoDesc:
      "365 questions people ask about Benson, AZ 85602 — Kartchner Caverns, RV parks, homes, schools, weather, restaurants and I-10 travel — one new answer every day.",
    catEyebrow: "Frequently asked questions about Benson",
    catHeading: "Twenty-one shelves of the gateway almanac",
    catSub:
      "Every one of the 365 questions lives under one of these twenty-one titles — from Kartchner Caverns tickets to the Amtrak stop and the 85602 ZIP.",
  },
  {
    slug: "douglas",
    path: "/douglas",
    name: "Douglas",
    zips: "85607",
    eyebrow: "The Douglas 365 Almanac",
    heroLines: ["*Eleven cities* of Southeast AZ.", "Answered daily."],
    heroSub:
      "Every question people ask about **Douglas, Arizona — ZIP 85607** — the Gadsden Hotel, the Agua Prieta border crossing, Pancho Villa-era history, ranchland, Mexican food and life on the line between two countries. One new in-depth AI answer, every single day.",
    heroSearchPlaceholder: "Ask about Douglas… e.g. border crossing hours, Gadsden Hotel",
    image: IMAGES.military,
    imageAlt: "Desert aviation and frontier landscape near Douglas, Arizona on the Mexican border",
    marquee: [
      "GATEWAY TO AGUA PRIETA",
      "THE GADSDEN HOTEL · EST. 1907",
      "ZIP 85607 · ON THE BORDER",
      "HOME OF THE 1ST AERO SQUADRON",
      "SAN BERNARDINO RANCH COUNTRY",
      "365 QUESTIONS · ONE NEW ANSWER DAILY",
      "COCHISE COUNTY FAIRGROUNDS",
    ],
    seoTitle: "365 Douglas AZ 85607 Questions, Answered Daily — YourRealtorFrank.info",
    seoDesc:
      "365 questions people ask about Douglas, AZ 85607 — the border crossing, Agua Prieta, the Gadsden Hotel, homes, schools and border life — one new answer every day.",
    catEyebrow: "Frequently asked questions about Douglas",
    catHeading: "Twenty shelves of the borderland almanac",
    catSub:
      "Every one of the 365 questions lives under one of these twenty titles — from port-of-entry hours to the Gadsden's marble staircase.",
  },
  {
    slug: "willcox",
    path: "/willcox",
    name: "Willcox",
    zips: "85643",
    eyebrow: "The Willcox 365 Almanac",
    heroLines: ["*Eleven cities* of Southeast AZ.", "Answered daily."],
    heroSub:
      "Every question people ask about **Willcox, Arizona — ZIP 85643** — Willcox Bench wine country, Rex Allen's cowboy legacy, Apple Annie's u-pick farms, Chiricahua National Monument and I-10 travel between Tucson and New Mexico. One new in-depth AI answer, every single day.",
    heroSearchPlaceholder: "Ask about Willcox… e.g. wine tasting, Rex Allen Days, Chiricahua",
    image: IMAGES.redrock,
    imageAlt: "Rock formations like the Chiricahua hoodoos near Willcox, Arizona wine country",
    marquee: [
      "ARIZONA WINE COUNTRY",
      "REX ALLEN · THE ARIZONA COWBOY",
      "GATEWAY TO CHIRICAHUA",
      "ZIP 85643 · SULPHUR SPRINGS VALLEY",
      "APPLE ANNIE'S U-PICK FARMS",
      "365 QUESTIONS · ONE NEW ANSWER DAILY",
      "SANDHILL CRANE WINTERS",
    ],
    seoTitle: "365 Willcox AZ 85643 Questions, Answered Daily — YourRealtorFrank.info",
    seoDesc:
      "365 questions people ask about Willcox, AZ 85643 — wine tasting, Chiricahua National Monument, Rex Allen Days, homes and vineyards — one new answer every day.",
    catEyebrow: "Frequently asked questions about Willcox",
    catHeading: "Nineteen shelves of the wine country almanac",
    catSub:
      "Every one of the 365 questions lives under one of these nineteen titles — from Willcox Bench vineyards to the Heart of Rocks loop.",
  },
  {
    slug: "sahuarita",
    path: "/sahuarita",
    name: "Sahuarita",
    zips: "85629",
    eyebrow: "The Sahuarita 365 Almanac",
    heroLines: ["*Eleven cities* of Southeast AZ.", "Answered daily."],
    heroSub:
      "Every question people ask about **Sahuarita, Arizona — ZIP 85629** — Rancho Sahuarita, the top-rated schools, the pecan groves, I-19 commutes into Tucson and the Titan Missile Museum next door. One new in-depth AI answer, every single day.",
    heroSearchPlaceholder: "Ask about Sahuarita… e.g. Rancho Sahuarita, schools, Titan Missile",
    image: IMAGES.dahlia,
    imageAlt: "Lush blooms like the gardens and pecan groves of Sahuarita, Arizona",
    marquee: [
      "ZIP 85629 · PIMA COUNTY",
      "RANCHO SAHUARITA",
      "TITAN MISSILE MUSEUM",
      "PECAN GROVE COUNTRY",
      "I-19 · 15 MIN SOUTH OF TUCSON",
      "SAHUARITA LAKE PARK",
      "365 QUESTIONS · ONE NEW ANSWER DAILY",
      "GATEWAY TO MADERA CANYON",
    ],
    seoTitle: "365 Sahuarita AZ 85629 Questions, Answered Daily — YourRealtorFrank.info",
    seoDesc:
      "365 questions people ask about Sahuarita, AZ 85629 — Rancho Sahuarita, schools, homes, I-19 commutes, restaurants and the Titan Missile Museum — one new answer every day.",
    catEyebrow: "Frequently asked questions about Sahuarita",
    catHeading: "Nineteen shelves of the suburb almanac",
    catSub:
      "Every one of the 365 questions lives under one of these nineteen titles — from Rancho Sahuarita amenities to the I-19 kilometer signs.",
  },
  {
    slug: "vail",
    path: "/vail",
    name: "Vail",
    zips: "85641",
    eyebrow: "The Vail 365 Almanac",
    heroLines: ["*Eleven cities* of Southeast AZ.", "Answered daily."],
    heroSub:
      "Every question people ask about **Vail, Arizona — ZIP 85641** — the top-rated Vail School District, Colossal Cave Mountain Park, Rancho del Lago, I-10 commutes and life at the foot of the Rincon Mountains. One new in-depth AI answer, every single day.",
    heroSearchPlaceholder: "Ask about Vail… e.g. Vail schools, Colossal Cave, Rita Ranch",
    image: IMAGES.redrock,
    imageAlt: "Rocky foothill terrain like the Rincon Mountains above Vail, Arizona",
    marquee: [
      "ZIP 85641 · PIMA COUNTY",
      "HOME OF THE VAIL SCHOOL DISTRICT",
      "COLOSSAL CAVE MOUNTAIN PARK",
      "I-10 · 25 MIN SE OF TUCSON",
      "RINCON MOUNTAIN VIEWS",
      "CIENEGA CREEK PRESERVE",
      "365 QUESTIONS · ONE NEW ANSWER DAILY",
      "A RAILROAD TOWN SINCE 1880",
    ],
    seoTitle: "365 Vail AZ 85641 Questions, Answered Daily — YourRealtorFrank.info",
    seoDesc:
      "365 questions people ask about Vail, AZ 85641 — Vail schools, Colossal Cave, homes, neighborhoods, I-10 commutes and Rincon Valley life — one new answer every day.",
    catEyebrow: "Frequently asked questions about Vail",
    catHeading: "Nineteen shelves of the foothills almanac",
    catSub:
      "Every one of the 365 questions lives under one of these nineteen titles — from Empire High School to the Colossal Cave tours.",
  },
  {
    slug: "sonoita",
    path: "/sonoita",
    name: "Sonoita",
    zips: "85637",
    eyebrow: "The Sonoita 365 Almanac",
    heroLines: ["*Eleven cities* of Southeast AZ.", "Answered daily."],
    heroSub:
      "Every question people ask about **Sonoita, Arizona — ZIP 85637** — Arizona's original wine region, the Elgin vineyards, rodeos, ranch land, dark skies and grassland life at 4,900 feet. One new in-depth AI answer, every single day.",
    heroSearchPlaceholder: "Ask about Sonoita… e.g. wine tasting, rodeo, ranch land",
    image: IMAGES.hummingbird,
    imageAlt: "Wildflower meadow like the rolling grasslands around Sonoita, Arizona wine country",
    marquee: [
      "ZIP 85637 · SANTA CRUZ COUNTY",
      "ARIZONA'S FIRST WINE REGION",
      "THE SONOITA AVA · EST. 1984",
      "ELEVATION 4,900 FT GRASSLANDS",
      "HWY 82 & 83 CROSSROADS",
      "SONOITA RODEO · COUNTY FAIR",
      "365 QUESTIONS · ONE NEW ANSWER DAILY",
      "12 MILES TO PATAGONIA",
    ],
    seoTitle: "365 Sonoita AZ 85637 Questions, Answered Daily — YourRealtorFrank.info",
    seoDesc:
      "365 questions people ask about Sonoita, AZ 85637 — wine tasting, Elgin wineries, rodeos, ranch land, weather and grassland living — one new answer every day.",
    catEyebrow: "Frequently asked questions about Sonoita",
    catHeading: "Nineteen shelves of the wine country almanac",
    catSub:
      "Every one of the 365 questions lives under one of these nineteen titles — from the Sonoita AVA tasting rooms to well depths on ranch land.",
  },
];

CITIES.sort((a, b) => a.name.localeCompare(b.name));

export const CITY_BY_SLUG = Object.fromEntries(CITIES.map((c) => [c.slug, c]));
